import React from 'react';
import { CalendarClock, MapPin, MessageCircle, Truck, Wallet } from 'lucide-react';
import { motion } from 'framer-motion';
import { DELIVERY_CITIES, INSTAGRAM_URL, PICKUP_ADDRESS, PICKUP_MAP_URL } from '../data/contact';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [CalendarClock, Wallet, MessageCircle];
export function OrderInfoSection() {
  const {
    t
  } = useLanguage();
  return <section id="commandes" className="scroll-mt-32 bg-cacao-900 py-20 md:py-28" data-id="element-175" data-mp="236ntjp6ofpv3">
      <div className="mx-auto max-w-7xl px-6 md:px-12" data-id="element-176" data-mp="284pdecbxft7m">
        <div className="mb-14 text-center" data-id="element-177" data-mp="286a7k0ubxa4y">
          <span className="mb-4 block font-sans text-xs uppercase tracking-[0.22em] text-caramel-light" data-id="element-178" data-mp="1udu8fb4jtw9b">
            {t.orderInfo.eyebrow}
          </span>
          <h2 className="mb-6 font-serif text-3xl text-creme md:text-4xl" data-id="element-179" data-mp="1yc9vtg4jl6n9">
            {t.orderInfo.titleLead}{' '}
            <span className="italic text-caramel-light" data-id="element-180" data-mp="2quoxslwtok4p">
              {t.orderInfo.titleAccent}
            </span>
          </h2>
          <p className="mx-auto max-w-2xl font-sans font-light leading-relaxed text-creme/75" data-id="element-181" data-mp="1o97llidoeuuz">
            {t.orderInfo.intro}
          </p>
        </div>

        <div className="mb-12 grid gap-8 md:grid-cols-3" data-id="element-182" data-mp="1xxza1gjj2x15">
          {t.orderInfo.cards.map((card, index) => {
          const Icon = icons[index] ?? CalendarClock;
          return <motion.article key={card.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.12
          }} className="border border-or/30 p-8" data-id="element-183" data-mp="1t5fxmmwku7xx" data-mpi={index}>
                <Icon size={26} strokeWidth={1.25} className="mb-5 text-caramel-light" aria-hidden="true" data-id="element-184" data-mp="2bz1yfzxzwjf8" />
                <h3 className="mb-4 font-serif text-xl text-creme" data-id="element-185" data-mp="hkr6him3t958">
                  {card.title}
                </h3>
                <p className="font-sans text-sm font-light leading-relaxed text-creme/70" data-id="element-186" data-mp="2hnjuibvkjfwx">
                  {card.text}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="grid gap-8 md:grid-cols-2" data-id="element-187" data-mp="2qlca7h57cpku">
          <div className="border border-or/30 bg-cacao-800 p-8" data-id="element-188" data-mp="2vm08mnvrg8p3">
            <h3 className="mb-5 flex items-center gap-3 font-serif text-xl text-creme" data-id="element-189" data-mp="30kuphka63n6k">
              <MapPin size={20} strokeWidth={1.5} className="text-caramel-light" aria-hidden="true" data-id="element-190" data-mp="30j0fh10fpfh9" />
              {t.orderInfo.pickupTitle}
            </h3>
            <a href={PICKUP_MAP_URL} target="_blank" rel="noopener noreferrer" className="font-sans font-light text-creme/85 underline decoration-caramel underline-offset-4 transition-colors hover:text-caramel-light" data-id="element-191" data-mp="3ecrcxb0w58wm">
              {PICKUP_ADDRESS}
            </a>
          </div>

          <div className="border border-or/30 bg-cacao-800 p-8" data-id="element-192" data-mp="2a9gwznpf8eu">
            <h3 className="mb-5 flex items-center gap-3 font-serif text-xl text-creme" data-id="element-193" data-mp="3te7y2d3eboqh">
              <Truck size={20} strokeWidth={1.5} className="text-caramel-light" aria-hidden="true" data-id="element-194" data-mp="3ofem4p3rc5sf" />
              {t.orderInfo.deliveryTitle}
            </h3>
            <ul className="mb-5 flex flex-wrap gap-2" data-id="element-195" data-mp="kyo9hrdo6uhr">
              {DELIVERY_CITIES.map(city => <li key={city} className="border border-caramel/40 px-3 py-1 font-sans text-[10px] uppercase tracking-[0.12em] text-creme/85" data-id="element-196" data-mp="g14talxew7n6">
                  {city}
                </li>)}
            </ul>
            <p className="font-sans text-sm font-light text-creme/70" data-id="element-197" data-mp="13qqt9bllyqw8">
              {t.orderInfo.deliveryNote}
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-5 border border-caramel/40 p-8 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-198" data-mp="jhh9mmm1fbnp">
          <div data-id="element-199" data-mp="ohvj893aetnu">
            <h3 className="mb-2 font-serif text-lg text-creme" data-id="element-200" data-mp="oe7nd3addv5y">
              {t.orderInfo.dmTitle}
            </h3>
            <p className="font-sans text-sm font-light text-creme/70" data-id="element-201" data-mp="aivqoqcnlume">
              {t.orderInfo.dmText}
            </p>
          </div>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="shrink-0 bg-caramel px-7 py-3.5 font-sans text-xs uppercase tracking-[0.14em] text-creme transition-colors hover:bg-caramel-light" data-id="element-202" data-mp="127fg4ya6swp8">
            {t.events.dmCta}
          </a>
        </div>
      </div>
    </section>;
}